import React from 'react'
import MessageView from './MessageView'

const AIMessage = ({ onLoading, className }) => (
  <MessageView className={className} onLoading={onLoading} />
)

export default AIMessage
